import React from "react";

import { IgPaper, IgTypography } from "@intelligems/ig-theme";
import { BarChartOutlined, School } from "@mui/icons-material";
import { Grid } from "@mui/material";

import { ContentTestIcon } from "../../../images/Icons/ContentTest/ContentTestIcon";
import { OfferTestIcon } from "../../../images/Icons/Offer/OfferTestIcon";
import { PriceTestIconFilled } from "../../../images/Icons/PriceTest/PriceTestIconFilled";
import { ShippingTestIcon } from "../../../images/Icons/ShippingTest/ShippingTestIcon";
import theme from "../../../theme";
import {
  analyzingResults,
  campaignTesting,
  contentTesting,
  introductionToIntelligems,
  personalizationsGettingStarted,
  priceIntegrationDocs,
  shippingTesting,
} from "../../../utils/linkSheet";
import openNewTab from "../../../utils/openNewTab";

const articleList = [
  {
    title: "Introduction to Intelligems",
    link: introductionToIntelligems,
    icon: (
      <School sx={{ fontSize: "40px", color: theme.palette.primary.main }} />
    ),
    description:
      "See what features and services Intelligems offers to help your business maximize profitability.",
  },
  {
    title: "Price Testing",
    link: priceIntegrationDocs,
    icon: <PriceTestIconFilled sx={{ fontSize: "35px" }} />,
    description:
      "Create real-time A/B tests for maximum profit, revenue, and conversion boosts.",
  },
  {
    title: "Shipping Testing",
    link: shippingTesting,
    icon: <ShippingTestIcon sx={{ fontSize: "40px" }} />,
    description: "Easily design personalized multi-group shipping rate tests.",
  },
  {
    title: "Content Testing",
    link: contentTesting,
    icon: <ContentTestIcon sx={{ fontSize: "40px" }} />,
    description:
      "Content tests tailored to Shopify merchants. Test landing pages, imagery, copy, themes, and more.",
  },
  {
    title: "Personalizations",
    link: personalizationsGettingStarted,
    icon: <OfferTestIcon sx={{ fontSize: "40px" }} />,
    description:
      "Custom tailor every visitor’s experience with targeted offers, layouts, branding and copy.",
  },
  {
    title: "Analyzing Results",
    link: analyzingResults,
    icon: (
      <BarChartOutlined
        sx={{ fontSize: "40px", color: theme.palette.primary.main }}
      />
    ),
    description:
      "Analytics overview, data export, and more. Make data-driven decisions with Intelligems.",
  },
];

export const Resources = () => {
  return (
    <Grid container direction={"column"} rowSpacing={2}>
      <Grid item>
        <IgTypography sx={{ fontSize: "24px", fontWeight: 600 }}>
          Explore Our Library of Resources
        </IgTypography>
      </Grid>
      <Grid
        item
        container
        direction={"row"}
        columnSpacing={1}
        rowSpacing={2}
        justifyContent={"space-between"}
      >
        {articleList.map((article, index) => (
          <Grid item xs={4} key={`article-${index}`}>
            <IgPaper
              sx={{
                padding: "20px 30px 20px 30px",
                minHeight: "137px",
                "&:hover": {
                  cursor: "pointer",
                  border: `1px solid ${theme.palette.primary.main}`,
                },
              }}
            >
              <Grid
                key={article.title}
                container
                item
                direction={"row"}
                onClick={() => {
                  openNewTab(article.link, article.title);
                }}
                justifyContent={"space-between"}
                columnSpacing={1}
              >
                <Grid item md={2.5}>
                  {article.icon}
                </Grid>
                <Grid md={9.5} item container direction={"column"}>
                  <Grid item>
                    <IgTypography sx={{ fontSize: "16px", fontWeight: 600 }}>
                      {article.title}
                    </IgTypography>
                  </Grid>
                  <Grid item>
                    <IgTypography
                      sx={{ fontSize: "14px" }}
                      color={"text.primary"}
                    >
                      {article.description}
                    </IgTypography>
                  </Grid>
                </Grid>
              </Grid>
            </IgPaper>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
